import { USER_CAPABILITY_CREATE_OPTIONS, USER_CAPABILITY_DELETE_OPTIONS, USER_CAPABILITY_EDIT_OPTIONS, USER_CAPABILITY_GRANT_PERMISSIONS, USER_CAPABILITY_MOVE_OPTION, USER_CAPABILITY_REVOKE_PERMISSIONS, } from './model/model';
// Accepts localId from the context. Expected: ari:cloud:ecosystem::extension/{appId}/{envId}/static/{appKeyFromManifest}
export const extractMinimalContextWithAppIdAndEnvIdFromLocalId = (ctx) => {
    const erroReturn = {
        appId: 'NO_APP_ID_FROM_LOCAL_ID',
        envId: 'NO_ENV_ID_FROM_LOCAL_ID',
        projectKey: 'FOO',
        projectType: 'software',
        extensionType: 'jira:projectPage',
    };
    if (!ctx || !ctx.context || !ctx.context.extension) {
        return erroReturn;
    }
    const localId = ctx.context.localId;
    const extensionType = ctx.context.extension.type;
    const projectKey = ctx.context.extension.project ? ctx.context.extension.project.key : undefined;
    const projectType = ctx.context.extension.project ? ctx.context.extension.project.type : undefined;
    const regexAppId = /^ari:cloud:ecosystem::extension\/([^/]+)\/.*/g;
    const matchAppId = regexAppId.exec(localId);
    const regexEnvId = /^ari:cloud:ecosystem::extension\/[^/]+\/([^/]+)\/.*/g;
    const matchEnvId = regexEnvId.exec(localId);
    if (matchEnvId && matchAppId) {
        return {
            appId: matchAppId[1],
            envId: matchEnvId[1],
            projectKey: projectKey,
            projectType: projectType,
            extensionType: extensionType,
        };
    }
    else {
        return erroReturn;
    }
};
export const generateUserCapabilitiesFromPermissions = (userOrGroupPermissions) => {
    const userCapabilities = [];
    if (userOrGroupPermissions && userOrGroupPermissions.isAdmin) {
        userCapabilities.push(USER_CAPABILITY_CREATE_OPTIONS);
        userCapabilities.push(USER_CAPABILITY_EDIT_OPTIONS);
        userCapabilities.push(USER_CAPABILITY_DELETE_OPTIONS);
        userCapabilities.push(USER_CAPABILITY_MOVE_OPTION);
        userCapabilities.push(USER_CAPABILITY_GRANT_PERMISSIONS);
        userCapabilities.push(USER_CAPABILITY_REVOKE_PERMISSIONS);
    }
    else {
        userCapabilities.push(USER_CAPABILITY_CREATE_OPTIONS);
        userCapabilities.push(USER_CAPABILITY_EDIT_OPTIONS);
        userCapabilities.push(USER_CAPABILITY_DELETE_OPTIONS);
        userCapabilities.push(USER_CAPABILITY_MOVE_OPTION);
    }
    return userCapabilities;
};
